import { oktaAuth } from "../../auth/services/oktaAuth";
import { log } from "../../shared/services/debug-logger";
import { apiUrl } from "../../shared/services/service";
import { AssistantWorkflow } from "../models/uwhc.models";
import { ASSISTANT_SOCKET_PATHS } from "../uwhc.constants";

// Opens the selected assistant through OpsLink using the same current Okta login as HTTP requests.
// Browsers cannot set an Authorization header on a WebSocket. CAPI must validate the query token
// and forward the matching bearer header before the backend accepts this connection.
export function openAssistantSocket(workflow: AssistantWorkflow): WebSocket {
  log("REPO - openAssistantSocket", { workflow });
  const accessToken = oktaAuth.getAccessToken();

  if (!accessToken) {
    log("REPO - openAssistantSocket - sign in required");
    throw new Error("Your login has expired. Sign in again to use the assistant.");
  }

  if (!apiUrl || apiUrl === "default-api-url") {
    throw new Error("The assistant connection is not configured. Please contact support.");
  }

  let socketUrl: URL;

  try {
    socketUrl = new URL(apiUrl, window.location.origin);
  } catch {
    throw new Error("The assistant connection is not configured. Please contact support.");
  }

  const isLoopback = ["localhost", "127.0.0.1", "[::1]"].includes(socketUrl.hostname);
  const hasSupportedProtocol = socketUrl.protocol === "https:" || (isLoopback && socketUrl.protocol === "http:");
  const hasUnsupportedBaseUrl =
    !hasSupportedProtocol || socketUrl.username || socketUrl.password || socketUrl.search || socketUrl.hash;

  if (hasUnsupportedBaseUrl) {
    throw new Error("The assistant connection is not configured. Please contact support.");
  }

  socketUrl.pathname = `${socketUrl.pathname.replace(/\/+$/, "")}/${ASSISTANT_SOCKET_PATHS[workflow]}`;
  socketUrl.protocol = socketUrl.protocol === "https:" ? "wss:" : "ws:";
  socketUrl.searchParams.set("access_token", accessToken);

  try {
    return new WebSocket(socketUrl);
  } catch {
    // Native connection errors can include the URL containing the login token.
    throw new Error("Unable to connect to the assistant. Please contact support.");
  }
}
